import 'core-js/modules/es.object.has-own';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './style.css';

// eruda 调试工具：?debug 开启并记住，?debug=0 关闭
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.has('debug')) {
  const debugValue = urlParams.get('debug');
  if (debugValue === '0' || debugValue === 'false') {
    localStorage.removeItem('eruda');
  } else {
    localStorage.setItem('eruda', '1');
  }
}
if (localStorage.getItem('eruda')) {
  import('eruda').then(({ default: eruda }) => {
    eruda.init();
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
